import { ProfileDetailsResponse, UnformattedProfileDataResponse } from '@/types'

/**
 * Format profile info API responses into a unified format since
 * each response contains different necessary profile data points
 */
export function formatRawProfileDetails(
  profileDetails: ProfileDetailsResponse,
  profileData: UnformattedProfileDataResponse,
) {
  const {
    contactInfo = {} as ProfileDetailsResponse['contactInfo'],
    profilePreferences = {} as ProfileDetailsResponse['profilePreferences'],
  } = profileDetails
  const { unformattedBusinessPhoneNumber, ...relevantContactInfo } = contactInfo

  const displayedContactInfo = {
    businessEmail: profilePreferences.emailAddressDisplay
      ? relevantContactInfo.businessEmail
      : null,
    businessPhoneNumber: profilePreferences.phoneNumberDisplay
      ? relevantContactInfo.businessPhoneNumber
      : null,
    businessWebsiteUrl: profilePreferences.websiteDisplay
      ? relevantContactInfo.businessWebsiteUrl
      : null,
  }

  return {
    coverPhoto: profileData.backgroundUrl,
    profilePhoto: profileData.avatarUrl,
    businessDescription:
      profileData.businessDescription || profileDetails.businessDescription,
    businessName: profileData.businessName,
    businessHandle: profileDetails.businessHandle,
    businessAddress: profileDetails.businessAddress,
    contactInfo: displayedContactInfo,
    allContactInfo: relevantContactInfo,
    profilePreferences,
  }
}
